import styled from '@emotion/styled'
import { Box } from '@mui/material'

const Page = styled(Box)`
	min-height: calc(100vh - 48px);
`

const Title = styled.div`
	margin-top: 20px;
	font-size: 20px;
	text-align: center;
	max-width: 350px;
`

const Subtitle = styled.div`
	margin-top: 20px;
	margin-bottom: 20px;
	font-size: 14px;
	max-width: 350px;
	text-align: center;
`

export { Page, Subtitle, Title }
